import React from 'react';

const LeaderBoard = (props) => {

    return (
        <div className={"leader-board-wrapper " + props.className}>
            <div className="leader-board-header leader-board-header-title">
                {props.title}
            </div>
            <div className="leader-board-body">
                {props.children}
            </div>
        </div>
    );
};

export default LeaderBoard;